import { Injector } from '@angular/core';

export class InovaAppInjector {
    static injector: Injector | undefined = undefined;
    
    static setInjector(injector: Injector) {
        InovaAppInjector.injector = injector;
    }

    static getInjector(): Injector {
        return InovaAppInjector.injector as Injector;
    }
}     